import { useUploader } from "../../../../contexts/uploaderContext/uploaderContext.js";
import { useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";
import handleAddFileUploader from "./handleAddFileUploader.js";
import useWaitForFilesModal from "./useWaitForFilesModal.js";

export const useUploaderInput = ({ filesRef, folderRef }) => {
  const { getUploader, uploaderAddFile, setTooManyVideos } = useUploader();
  const { onStart, onEnd } = useWaitForFilesModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  const handleAddFiles = () => {
    filesRef.current?.click();
  };

  const handleAddFolders = () => {
    folderRef.current?.click();
  };

  const addFilesEvent = (event) => {
    onStart();
    const files = Array.from(event.target.files);

    const tooManyVideos =
      files.filter((file) => file.type.includes("video")).length > 50;
    if (tooManyVideos) {
      setTooManyVideos(true);
    }

    files?.forEach(async (file) => {
      await handleAddFileUploader(
        file,
        uploaderAddFile,
        addToast,
        getTextByKey,
        null, // relativePath
        tooManyVideos
      );
    });
    onEnd();
  };

  const addFoldersEvent = (event) => {
    onStart();
    const files = Array.from(event.target.files);

    const tooManyVideos =
      files.filter((file) => file.type.includes("video")).length > 50;
    if (tooManyVideos) {
      setTooManyVideos(true);
    }

    files.forEach(async (file) => {
      await handleAddFileUploader(
        file,
        uploaderAddFile,
        addToast,
        getTextByKey,
        file.webkitRelativePath,
        tooManyVideos
      );
    });
    onEnd();
  };

  const resetInputs = () => {
    filesRef.current.value = "";
    folderRef.current.value = "";
  };

  useEffect(() => {
    const fileInputRef = filesRef.current;
    const folderInputRef = folderRef.current;
    if (getUploader()) {
      fileInputRef?.addEventListener("click", resetInputs);
      folderInputRef?.addEventListener("click", resetInputs);
      fileInputRef?.addEventListener("change", addFilesEvent);
      folderInputRef?.addEventListener("change", addFoldersEvent);

      return () => {
        fileInputRef?.removeEventListener("click", resetInputs);
        folderInputRef?.removeEventListener("click", resetInputs);
        fileInputRef?.removeEventListener("change", addFilesEvent);
        folderInputRef?.removeEventListener("change", addFoldersEvent);
      };
    }
  }, [getUploader(), filesRef.current, folderRef.current]);

  return { handleAddFiles, handleAddFolders };
};
